module.exports = __webpack_public_path__ + "static/68invgde-b2b467cc876ebb2a374d6ff5415db5ae.gif";